import { STAR_BANK_NAMESPACE_ID, APPLICANT } from "src/constants"
import { PERSONALLOANS, SECURED, UNSECURED } from "src/features/LoansHome/Products/constants"
import { STATUS_APPLICATION_STARTED, STATUS_SUBMITTED, STATUS_UNDER_REVIEW, STATUS_APPROVED, STATUS_CLEAR_TO_CLOSE_COMPLETED, STATUS_BOOKING_COMPLETE, SMARTMATCH_TYPE_LOAN_OFFICER, SMARTMATCH_TYPE_LOAN_ASSISTANT, SMARTMATCH_TYPE_ADMIN, SMARTMATCH_TYPE_LOAN_PROCESSOR, SMARTMATCH_TYPE_RATE_APPROVER, STATUS_APPROVED_NOT_ACCEPTED, STATUS_CLOSED_FOR_INCOMPLETENESS, STATUS_CREDIT_APPROVAL, STATUS_DECLINED, STATUS_DENIAL_UNDER_REVIEW, STATUS_PRE_QUALIFIED, STATUS_RECOMMENDED_APPROVE, STATUS_RECOMMENDED_DECLINE, STATUS_REQUEST_APPROVAL, STATUS_SOFT_DECLINED, STATUS_UNTOUCHED, STATUS_WITHDRAW } from "src/services/constants"
import { ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT, ADVISOR_LENDING_LIMIT_EXCEEDS, ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY, ADVISOR_LOAN_TERMS_UNDER_12_MONTHS_OF_POLICY } from "src/features/RBAC/Rules/permissionData"





export const applicantStages = {
    id: '154878745215745754',
    namespace_id: STAR_BANK_NAMESPACE_ID,
    loan_type: [PERSONALLOANS],
    sub_loan_types: [SECURED, UNSECURED],
    stages: [
        {
            name: STATUS_APPLICATION_STARTED,
            display_name: STATUS_APPLICATION_STARTED,
            order_id: 1,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_SUBMITTED,
                            display_name: STATUS_SUBMITTED,
                        }
                    ]
                },
            ]
        },
        {
            name: STATUS_SUBMITTED,
            display_name: STATUS_SUBMITTED,
            order_id: 2,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_UNDER_REVIEW,
                            display_name: STATUS_UNDER_REVIEW,
                        }
                    ]
                },
            ]
        },
        {
            name: STATUS_UNDER_REVIEW,
            display_name: STATUS_UNDER_REVIEW,
            order_id: 3,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_APPROVED,
                            display_name: STATUS_APPROVED,
                        }
                    ]
                },
            ]
        },
        {
            name: STATUS_APPROVED,
            display_name: STATUS_APPROVED,
            order_id: 5,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
                            display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
                        }
                    ]
                },
            ]
        },
        {
            name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
            display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
            order_id: 6,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_BOOKING_COMPLETE,
                            display_name: STATUS_BOOKING_COMPLETE,
                        }
                    ]
                },
            ]
        }
    ],
    roles: [APPLICANT],
} as any


const stageStarted = {
    name: STATUS_APPLICATION_STARTED,
    display_name: STATUS_APPLICATION_STARTED,
    order_id: 1,
    children: [
        {
            stages: [
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                    display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                }
            ]
        },
    ]
}

const stageStartedAdmin = {
    name: STATUS_APPLICATION_STARTED,
    display_name: STATUS_APPLICATION_STARTED,
    order_id: 1,
    children: [
        {
            stages: [
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                    display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                }
            ]
        },
    ]
}



const stageUnderReview = {
    name: STATUS_UNDER_REVIEW,
    display_name: STATUS_RECOMMENDED_DECLINE,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                    order: 5
                },
                {
                    name: STATUS_CREDIT_APPROVAL,
                    display_name: STATUS_CREDIT_APPROVAL,
                    order: 3
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                }
            ]
        }
    ]
}

const stageUnderReviewAdminOnly = {
    name: STATUS_UNDER_REVIEW,
    display_name: STATUS_RECOMMENDED_DECLINE,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                    order: 5
                },
                {
                    name: STATUS_CREDIT_APPROVAL,
                    display_name: STATUS_CREDIT_APPROVAL,
                    order: 3
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                }
            ]
        }
    ]
}

const stageUnderReviewAdmin = {
    name: STATUS_UNDER_REVIEW,
    display_name: STATUS_RECOMMENDED_DECLINE,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                    order: 5
                },
                {
                    name: STATUS_CREDIT_APPROVAL,
                    display_name: STATUS_CREDIT_APPROVAL,
                    order: 3
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                }
            ]
        }
    ]
}

const stageDenialUnderReviewAdminOnly = {
    name: STATUS_DENIAL_UNDER_REVIEW,
    display_name: STATUS_DENIAL_UNDER_REVIEW,
    children: [
        {
            stages: [
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                },
            ]
        }
    ]
}

const stageDenialUnderReview = {
    name: STATUS_DENIAL_UNDER_REVIEW,
    display_name: STATUS_DENIAL_UNDER_REVIEW,
    children: [
        {
            stages: [
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                },
            ]
        }
    ]
}

const stageSubmitted = {
    name: STATUS_SUBMITTED,
    display_name: STATUS_SUBMITTED,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_UNDER_REVIEW,
                    display_name: STATUS_RECOMMENDED_DECLINE,
                    order: 3
                },
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                    order: 5
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },

                {
                    name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                    display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                }
            ]
        },
    ]
}

const stageSubmittedAdmin = {
    name: STATUS_SUBMITTED,
    display_name: STATUS_SUBMITTED,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_UNDER_REVIEW,
                    display_name: STATUS_RECOMMENDED_DECLINE,
                    order: 3
                },
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                    order: 5
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },

                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                    display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                }
            ]
        },
    ]
}


const stagePreQualifiedAdmin = {
    name: STATUS_PRE_QUALIFIED,
    display_name: STATUS_RECOMMENDED_APPROVE,
    order_id: 2,
    children: [
        {
            permission: ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT,
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                }
            ]
        },
        {

            stages: [
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                    order: 5
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ]
        },
    ]
}
const stageApproval = {
    name: STATUS_REQUEST_APPROVAL,
    display_name: STATUS_REQUEST_APPROVAL,
    order_id: 2,
    children: [
        {
            permission: ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT,
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ]
        },
        {
            permission: ADVISOR_LENDING_LIMIT_EXCEEDS,
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ]
        },
        {
            stages: [
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                    order: 5
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ]
        },
    ]
}

const stageApprovalAdmin = {
    name: STATUS_REQUEST_APPROVAL,
    display_name: STATUS_REQUEST_APPROVAL,
    order_id: 2,
    children: [
        {
            permission: ADVISOR_LENDING_LIMIT_EXCEEDS,
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                }
            ]
        },
        {
            stages: [
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                    order: 5
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ]
        },
    ]
}

const stageCreditApproval = {
    name: STATUS_CREDIT_APPROVAL,
    display_name: STATUS_CREDIT_APPROVAL,
    order_id: 2,
    children: [
        {
            permission: ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT,
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ]
        },
        {
            stages: [
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                    order: 5,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ]

        }
    ]
}


const stageCreditApprovalAdmin = {
    name: STATUS_CREDIT_APPROVAL,
    display_name: STATUS_CREDIT_APPROVAL,
    order_id: 2,
    children: [

        {
            stages: [
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                    order: 5,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ]

        }
    ]
}



const stageApproved = {
    name: STATUS_APPROVED,
    display_name: STATUS_APPROVED,
    order_id: 2,
    children: [
        {
            stages: [

                {
                    name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
                    display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
                    order: 5
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ]
        },
    ]
}


const stageApprovedAdmin = {
    name: STATUS_APPROVED,
    display_name: STATUS_APPROVED,
    order_id: 2,
    children: [
        {
            stages: [

                {
                    name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
                    display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
                    order: 5
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ]
        },
    ]
}


const stageWithdrawn = {
    name: STATUS_WITHDRAW,
    display_name: STATUS_WITHDRAW,
    order_id: 2,
    children: []
}

const stageClosedForIncomplete = {
    name: STATUS_CLOSED_FOR_INCOMPLETENESS,
    display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
    order_id: 2,
    children: []
}

const stageUntouched = {
    name: STATUS_UNTOUCHED,
    display_name: STATUS_UNTOUCHED,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_UNDER_REVIEW,
                    display_name: STATUS_RECOMMENDED_DECLINE,
                },
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                    display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                }
            ]
        }
    ]
}

const stageUntouchedAdmin = {
    name: STATUS_UNTOUCHED,
    display_name: STATUS_UNTOUCHED,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_UNDER_REVIEW,
                    display_name: STATUS_RECOMMENDED_DECLINE,
                },
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                    display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                }
            ]
        }
    ]
}

const stageSoftDeclined = {
    name: STATUS_SOFT_DECLINED,
    display_name: STATUS_SOFT_DECLINED,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_UNDER_REVIEW,
                    display_name: STATUS_RECOMMENDED_DECLINE,
                    order: 3
                },
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                    order: 5
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW
                }
            ]
        }
    ]
}


const stageClearToCloseForSecuredUnSecuredRM = {
    name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
    display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
    children: [
        {
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ]
        },
    ]
}



const stageClearToCloseForSecuredUnSecured = {
    name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
    display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
    children: [
        {
            stages: [
                {
                    name: STATUS_BOOKING_COMPLETE,
                    display_name: STATUS_BOOKING_COMPLETE
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ]
        },
    ]
}



const stagePreQualified = {
    name: STATUS_PRE_QUALIFIED,
    display_name: STATUS_RECOMMENDED_APPROVE,
    order_id: 2,
    children: [
        {
            permission: ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY,
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                }
            ]
        },
        {
            permission: ADVISOR_LOAN_TERMS_UNDER_12_MONTHS_OF_POLICY,
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                }
            ]
        },
        {
            permission: ADVISOR_PROPOSED_INTEREST_RATE_ABOVE_ONE_PERCENT,
            stages: [
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                }
            ]
        },
        {
            stages: [
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                    order: 5
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                }
            ]
        },
    ]
}

export const loStageConfigs = {
    id: '154878745215745754',
    namespace_id: STAR_BANK_NAMESPACE_ID,
    loan_type: [PERSONALLOANS],
    sub_loan_types: [SECURED, UNSECURED],
    stages: [
        stageStarted,
        stageSubmitted,
        stageUnderReview,
        stagePreQualified,
        stageCreditApproval,
        stageApproval,
        stageApproved,
        stageWithdrawn,
        stageClosedForIncomplete,
        stageClearToCloseForSecuredUnSecuredRM,
        stageUntouched,
        stageSoftDeclined
    ],
    roles: [SMARTMATCH_TYPE_LOAN_OFFICER, SMARTMATCH_TYPE_LOAN_ASSISTANT],
} as any



export const adminOnlyStageConfigs = {
    id: '154878745215745754',
    namespace_id: STAR_BANK_NAMESPACE_ID,
    loan_type: [PERSONALLOANS],
    sub_loan_types: [SECURED, UNSECURED],
    stages: [
        stageStartedAdmin,
        stageSubmittedAdmin,
        stageUnderReviewAdminOnly,
        stagePreQualifiedAdmin,
        stageApprovalAdmin,
        stageCreditApprovalAdmin,
        stageDenialUnderReviewAdminOnly,
        stageApprovedAdmin,
        stageWithdrawn,
        stageClosedForIncomplete,
        stageClearToCloseForSecuredUnSecured,
        stageUntouchedAdmin,
        stageSoftDeclined
    ],
    roles: [
        SMARTMATCH_TYPE_ADMIN,
    ],
} as any


export const loOnlyStageConfig = {
    id: '154878745215745754',
    namespace_id: STAR_BANK_NAMESPACE_ID,
    loan_type: [PERSONALLOANS],
    sub_loan_types: [SECURED, UNSECURED],
    stages: [
        stageStartedAdmin,
        stageSubmittedAdmin,
        stageUnderReviewAdmin,
        stagePreQualifiedAdmin,
        stageApprovalAdmin,
        stageCreditApprovalAdmin,
        stageDenialUnderReview,
        stageApprovedAdmin,
        stageWithdrawn,
        stageClosedForIncomplete,
        stageClearToCloseForSecuredUnSecured,
        stageUntouchedAdmin,
        stageSoftDeclined
    ],
    roles: [
        SMARTMATCH_TYPE_LOAN_PROCESSOR
    ],
} as any


export const rateApproverStageConfigs = {
    id: '154878745215745754',
    namespace_id: STAR_BANK_NAMESPACE_ID,
    loan_type: [PERSONALLOANS],
    sub_loan_types: [SECURED, UNSECURED],
    stages: [
        stageStarted,
        stageSubmitted,
        stageUnderReview,
        stagePreQualifiedAdmin,
        stageApprovalAdmin,
        stageCreditApprovalAdmin,
        stageApproved,
        stageWithdrawn,
        stageClosedForIncomplete,
        stageClearToCloseForSecuredUnSecuredRM,
        stageUntouched,
        stageSoftDeclined
    ],
    roles: [SMARTMATCH_TYPE_RATE_APPROVER],
} as any

